module.exports = __webpack_public_path__ + "static/media/ip-negotiation.9d4105bb.jpeg";